import BaseClass from "../util/BaseClass";
import * as esriLoader from "esri-loader";

export default class EsriLib extends BaseClass {

  lib = {
    esri: {},
    dojo: {},
    dojox: {},
    indoors: {}
  };

  load(options) {
    return esriLoader.loadModules([
      "esri/config",
      "esri/core/watchUtils",
      "esri/core/promiseUtils",
      "esri/core/unitUtils",
      "esri/core/urlUtils",
      "esri/geometry/Circle",
      "esri/geometry/Extent",
      "esri/geometry/geometryEngine",
      "esri/geometry/Point",
      "esri/geometry/Polygon",
      "esri/geometry/Polyline",
      "esri/geometry/SpatialReference",
      "esri/geometry/support/jsonUtils",
      "esri/geometry/support/scaleUtils",
      "esri/geometry/support/webMercatorUtils",
      "esri/Graphic",
      "esri/identity/IdentityManager",
      "esri/identity/OAuthInfo",
      "esri/kernel",
      "esri/layers/FeatureLayer",
      "esri/layers/GraphicsLayer",
      "esri/layers/support/LayerFloorInfo",
      "esri/PopupTemplate",
      "esri/portal/Portal",
      "esri/portal/PortalItem",
      "esri/renderers/support/jsonUtils",
      "esri/request",
      "esri/symbols/PictureMarkerSymbol",
      "esri/symbols/SimpleLineSymbol",
      "esri/symbols/SimpleMarkerSymbol",
      "esri/symbols/TextSymbol",
      "esri/tasks/ClosestFacilityTask",
      "esri/tasks/GeometryService",
      "esri/tasks/PrintTask",
      "esri/tasks/QueryTask",
      "esri/tasks/support/ClosestFacilityParameters",
      "esri/tasks/support/DataFile",
      "esri/tasks/support/FeatureSet",
      "esri/tasks/support/PrintParameters",
      "esri/tasks/support/PrintTemplate",
      "esri/tasks/support/ProjectParameters",
      "esri/tasks/support/Query",
      "esri/tasks/support/StatisticDefinition",
      "esri/Viewpoint",
      "esri/views/MapView",
      "esri/views/SceneView",
      "esri/views/support/WebGLRequirements",
      "esri/WebMap",
      "esri/WebScene",
      "esri/widgets/BasemapGallery",
      "esri/widgets/Compass",
      "esri/widgets/Directions/support/maneuverUtils",
      "esri/widgets/Expand",
      "esri/widgets/Feature",
      "esri/widgets/FloorFilter",
      "esri/widgets/Home",
      "esri/widgets/LayerList",
      "esri/widgets/Legend",
      "esri/widgets/Popup",
      "esri/widgets/Search",
      "esri/widgets/ScaleBar",
      "esri/widgets/Sketch/SketchViewModel",
      "esri/widgets/Track",

      "dojo/aspect",
      "dojo/_base/fx",
      "dojo/_base/kernel",
      "dojo/_base/window",
      "dojo/date/locale",
      "dojo/date/stamp",
      "dojo/dom",
      "dojo/dom-class",
      "dojo/dom-construct",
      "dojo/dom-geometry",
      "dojo/dom-style",
      "dojo/io-query",
      "dojo/number",
      "dojo/query",
      "dojo/sniff",
      "dojo/topic",
      "dojox/uuid/generateRandomUuid",

      "ts/tslib/widgets/Directions/CustomDirections.js",
      "ts/tslib/widgets/Directions/CustomDirectionsViewModel.js",
      "ts/tslib/widgets/Directions/customSolve.js",
      "ts/tslib/widgets/Directions/Steps.js",
      "ts/tslib/widgets/FeatureForm/CustomFeatureForm.js",
      "ts/tslib/widgets/LayerList/CustomLayerList.js",
      "ts/tslib/widgets/Search/CustomSearch.js",
      "ts/tslib/util/requireUtil.js"

    ],options).then(([
      esriConfig,
      watchUtils,
      promiseUtils,
      unitUtils,
      urlUtils,
      Circle,
      Extent,
      geometryEngine,
      Point,
      Polygon,
      Polyline,
      SpatialReference,
      geometryJsonUtils,
      scaleUtils,
      webMercatorUtils,
      Graphic,
      esriId,
      OAuthInfo,
      esriNS ,
      FeatureLayer,
      GraphicsLayer,
      LayerFloorInfo,
      PopupTemplate,
      Portal,
      PortalItem,
      rendererJsonUtils,
      esriRequest,
      PictureMarkerSymbol,
      SimpleLineSymbol,
      SimpleMarkerSymbol,
      TextSymbol,
      ClosestFacilityTask,
      GeometryService,
      PrintTask,
      QueryTask,
      ClosestFacilityParameters,
      DataFile,
      FeatureSet,
      PrintParameters,
      PrintTemplate,
      ProjectParameters,
      Query,
      StatisticDefinition,
      Viewpoint,
      MapView,
      SceneView,
      WebGLRequirements,
      WebMap,
      WebScene,
      BasemapGallery,
      Compass,
      maneuverUtils,
      Expand,
      Feature,
      FloorFilter,
      Home,
      LayerList,
      Legend,
      Popup,
      Search,
      ScaleBar,
      SketchViewModel,
      Track,

      djAspect,
      djFx,
      djKernel,
      djWindow,
      djLocale,
      djStamp,
      dom,
      domClass,
      domConstruct,
      domGeom,
      domStyle,
      djIoQuery,
      djNumber,
      djQuery,
      djSniff,
      djTopic,
      djxGenerateRandomUuid,

      CustomDirections,
      CustomDirectionsViewModel,
      customSolve,
      Steps,
      CustomFeatureForm,
      CustomLayerList,
      CustomSearch,
      requireUtil

    ]) => {
      let lib = this.lib;

      lib.esri.esriConfig = esriConfig;
      lib.esri.watchUtils = watchUtils;
      lib.esri.promiseUtils = promiseUtils;
      lib.esri.unitUtils = unitUtils;
      lib.esri.urlUtils = urlUtils;
      lib.esri.Circle = Circle;
      lib.esri.Extent = Extent;
      lib.esri.geometryEngine= geometryEngine;
      lib.esri.Point = Point;
      lib.esri.Polygon = Polygon;
      lib.esri.Polyline = Polyline;
      lib.esri.SpatialReference = SpatialReference;
      lib.esri.geometryJsonUtils = geometryJsonUtils;
      lib.esri.scaleUtils = scaleUtils;
      lib.esri.webMercatorUtils = webMercatorUtils;
      lib.esri.Graphic = Graphic;
      lib.esri.esriId = esriId;
      lib.esri.OAuthInfo = OAuthInfo;
      lib.esri.esriNS = esriNS;
      lib.esri.FeatureLayer = FeatureLayer;
      lib.esri.GraphicsLayer = GraphicsLayer;
      lib.esri.LayerFloorInfo = LayerFloorInfo;
      lib.esri.PopupTemplate = PopupTemplate;
      lib.esri.Portal = Portal;
      lib.esri.PortalItem = PortalItem;
      lib.esri.rendererJsonUtils = rendererJsonUtils;

      lib.esri.esriRequest = esriRequest;
      lib.esri.PictureMarkerSymbol = PictureMarkerSymbol;
      lib.esri.SimpleLineSymbol = SimpleLineSymbol;
      lib.esri.SimpleMarkerSymbol = SimpleMarkerSymbol;
      lib.esri.TextSymbol = TextSymbol;
      lib.esri.ClosestFacilityTask = ClosestFacilityTask;
      lib.esri.GeometryService = GeometryService;
      lib.esri.PrintTask = PrintTask;
      lib.esri.QueryTask = QueryTask;
      lib.esri.ClosestFacilityParameters = ClosestFacilityParameters;
      lib.esri.DataFile = DataFile;
      lib.esri.FeatureSet = FeatureSet;
      lib.esri.PrintParameters = PrintParameters;
      lib.esri.PrintTemplate = PrintTemplate;
      lib.esri.ProjectParameters = ProjectParameters;
      lib.esri.Query = Query;
      lib.esri.StatisticDefinition = StatisticDefinition;
      lib.esri.Viewpoint = Viewpoint;
      lib.esri.MapView = MapView;
      lib.esri.SceneView = SceneView;
      lib.esri.WebGLRequirements = WebGLRequirements;
      lib.esri.WebMap = WebMap;
      lib.esri.WebScene = WebScene;
      lib.esri.BasemapGallery = BasemapGallery;
      lib.esri.Compass = Compass;
      lib.esri.maneuverUtils = maneuverUtils;
      lib.esri.Expand = Expand;
      lib.esri.Feature = Feature;
      lib.esri.FloorFilter = FloorFilter;
      lib.esri.Home = Home;
      lib.esri.LayerList = LayerList;
      lib.esri.Legend = Legend;
      lib.esri.Popup = Popup;
      lib.esri.Search = Search;
      lib.esri.ScaleBar = ScaleBar;
      lib.esri.SketchViewModel = SketchViewModel;
      lib.esri.Track = Track;

      lib.dojo.aspect = djAspect;
      lib.dojo.fx = djFx;
      lib.dojo.kernel = djKernel;
      lib.dojo.window = djWindow;
      lib.dojo.locale = djLocale;
      lib.dojo.stamp = djStamp;
      lib.dojo.dom = dom;
      lib.dojo.domClass = domClass;
      lib.dojo.domConstruct = domConstruct;
      lib.dojo.domGeom = domGeom;
      lib.dojo.domStyle = domStyle;
      lib.dojo.ioQuery = djIoQuery;
      lib.dojo.number = djNumber;
      lib.dojo.query = djQuery;
      lib.dojo.sniff = djSniff;
      lib.dojo.topic = djTopic;
      lib.dojox.generateRandomUuid = djxGenerateRandomUuid;

      lib.indoors.CustomDirections = CustomDirections.default;
      lib.indoors.CustomDirectionsViewModel = CustomDirectionsViewModel.default;
      lib.indoors.customSolve = customSolve;
      lib.indoors.Steps = Steps.default;
      lib.indoors.CustomFeatureForm = CustomFeatureForm.default;
      lib.indoors.CustomLayerList  = CustomLayerList.default;
      lib.indoors.CustomSearch = CustomSearch.default;
      lib.indoors.requireUtil = requireUtil;

      //console.log("esriNS.version",esriNS.version);

    });
  }

}
